function getScrollParent (node) {
  if (! node) {
    return null;
  }
  if (node.classList?.contains('gmf-modal-overlay') || node.classList?.contains('gmf-scrollable')) {
    return node
  } else {
    return getScrollParent(node.parentNode);
  }
}

export default getScrollParent;
